import React from 'react'
import Layout from '../../components/Layout'
import Container from '../../components/Container'
import SEO from '../../components/SEO'

const ServicesWeProvide = () => {
    return (
        <Layout>
            <SEO title="Services we provide" description="Check the services that you can obtain from us!" />
            <Container>
                <div className="services-provide"></div>
                <section className="blog_w3ls" id="provide">
	            	<div className="container py-xl-5 py-lg-3">
	            		<div className="row">
	            			<article className="col-lg-6 col-md-6">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0"></div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">Pain Management</h5>
	            						</div>
	            						<p>Pain management is one of the primary goals of hospice service. At A-Z Hospice our goal is keeping the patient comfortable and managing symptoms to ensure the quality and expectancy of end of life care have been met. In addition to pain medication, the use of traditional psychological interventions such as biofeedback, hypnosis, relaxation, and imagery techniques are used to provide skills that increase the client’s awareness and control of pain. The hospice care team will evaluate a patient’s pain on every visit using pain rating scales and the expertise of the clinician.</p>
	            					</div>
	            				</div>
	            			</article>
	            			<article className="col-lg-6 col-md-6 mt-lg-0 mt-5">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0"></div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">Continuous Home Care</h5>
	            						</div>
	            						<p>Continuous Home Care is typically used during times of crisis. If your loved one is suffering to manage their medical symptoms and needs palliation, this care provides continuous nursing to help relieve that pain. Continuous Home Care is provided at the patient’s home or assisted living facility so they can remain comfortable during these hard times Continuous Care for terminally ill patients is one of four types of hospice care covered by the Medicare Hospice Benefit. This round-the-clock level of care is provided in the home for brief periods of time when the patient is experiencing a crisis. It is designed to honor a patient’s wish to remain at home by providing the care needed to control the patient’s symptoms and alleviate the crisis.</p>
	            					</div>
	            				</div>
	            			</article>
	            			<article className="col-lg-6 col-md-6 mt-md-0 mt-5">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0"></div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">24 Hour Hospice Care</h5>
	            						</div>
	            						<p>At A-Z Hospice, Our On-Call Skilled nurses available 24 hours a day. Continuous care staff for pain management and control. 24-hour pharmacy for patients requiring emergency medicine. Durable medical equipment is available.</p>
	            					</div>
	            				</div>
	            			</article>
	            			<article className="col-lg-6 col-md-6 mt-md-0 mt-5">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0">
	            					</div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">Professional Nurses and Aides</h5>
	            						</div>
	            						<p>At A-Z Hospice our professional Staff are board approved Nurses and Professional Aides, Our doctors are board approved and are available 24/7. Our Nurses are also available 24/7. Our goal at A-Z Hospice is to care from our hearts. We know every minute is valuable for our patients..</p>
	            					</div>
	            				</div>
	            			</article>
	            			<article className="col-lg-6 col-md-6 mt-md-0 mt-5">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0">
	            					</div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">Spiritual and Emotional Care</h5>
	            						</div>
	            						<p>Spiritual and Emotional care is an essential part of hospice and is often offered through the support of a Hospice Chaplain. At A-Z Hospice our team of Spiritual Care counselors are clinically trained and nationally certified. We are innovative and utilize a focus on addressing overall divine health to provide peace and comfort. At A-Z Hospice our counselors also focus on the emotional aspect of our patients..</p>
	            					</div>
	            				</div>
	            			</article>
	            			<article className="col-lg-6 col-md-6 mt-md-0 mt-5">
	            				<div className="card border-0 med-blog">
	            					<div className="card-header p-0"></div>
	            					<div className="card-body border border-top-0">
	            						<div className="mb-3">
	            							<h5 className="blog-title card-title m-0">Respite Care For Primary Caregivers</h5>
	            						</div>
	            						<p>If you are the primary caregiver of your loved one and feel help is needed. Our Hospice service will give you the break you deserve. Our goal is to help both your loved one and you feel at your best. Respite Care is sustained in a hospital, hospice unit, or long-term care facility. At A-Z Hospice our Respite care is short-term relief for in-home hospice caregivers. Medicare benefits pay for patient transport and up to five consecutive days of inpatient care at a Medicare-approved nursing facility or hospital. You can get respite care more than once, but only on an occasional basis.</p>
	            					</div>
	            				</div>
	            			</article>
	            		</div>
	            	</div>
	            </section>
            </Container>
        </Layout>
    )
}

export default ServicesWeProvide
